import React from 'react';

const Email = () => (
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 58">
    <path
      d="M7.143 3.572A7.15 7.15 0 0 0 0 10.714V46.43a7.15 7.15 0 0 0 7.143 7.142h35.714A7.15 7.15 0 0 0 50 46.43V10.714a7.15 7.15 0 0 0-7.143-7.142H7.143ZM24.33 30.324 7.165 19.24a3.567 3.567 0 0 1 3.55-3.17h28.57a3.567 3.567 0 0 1 3.55 3.17L25.67 30.324c-.201.134-.436.2-.67.2-.234 0-.469-.066-.67-.2Zm3.282 3.002 15.245-9.844V37.5a3.567 3.567 0 0 1-3.571 3.572H10.714A3.568 3.568 0 0 1 7.143 37.5V23.482l15.245 9.844c.782.502 1.686.77 2.612.77.926 0 1.83-.268 2.612-.77Z"
      fill="#fff"
    />
  </svg>
);

export default Email;
